import React, { useState } from "react";
import { COLORS, ACHIEVEMENTS } from "../data/profile";
import { useLang, t } from "../LanguageContext";
import ScrollReveal from "./ScrollReveal";

const CHRONOLOGICAL_ORDER = [4, 2, 1, 3, 0]; // PwC → FFUND → Ministry → Gov AI → EdoMatch

const PERIODS = {
  0: "2022–present",
  1: "2023–2025",
  2: "2019–2021",
  3: "2024–present",
  4: "2015–2019",
};

export default function StorySection() {
  const { lang } = useLang();
  const [expanded, setExpanded] = useState(null);

  return (
    <section className="story-section">
      <div className="section-inner">
        <ScrollReveal>
          <h2 className="section-heading">
            {lang === "en" ? "Track Record" : "Parcours"}
          </h2>
        </ScrollReveal>

        <div className="story-cards">
          {CHRONOLOGICAL_ORDER.map((origIdx, i) => {
            const a = ACHIEVEMENTS[origIdx];
            return <ScrollReveal key={origIdx} delay={i * 120}>
              <div
                className={`story-card ${expanded === origIdx ? "is-expanded" : ""}`}
                onClick={() => setExpanded(expanded === origIdx ? null : origIdx)}
              >
                <div className="story-period">{PERIODS[origIdx]}</div>
                <div className="story-bullet">{t(a.bullet, lang)}</div>
                <div className="story-sub">{t(a.sub, lang)}</div>

                {expanded !== origIdx && (
                  <div className="story-expand-hint">
                    {lang === "en" ? "Tap to read more" : "Appuyez pour en savoir plus"}
                  </div>
                )}

                {expanded === origIdx && (
                  <div className="story-full">
                    <p>{t(a.story, lang)}</p>
                    <div className="story-tags">
                      {a.tags.map((tag) => (
                        <span key={tag} className="story-tag">{tag}</span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </ScrollReveal>;
          })}
        </div>
      </div>
    </section>
  );
}
